import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'form',
		'inputMonth',
		'inputYear',
		'inputDateRange',
	]

	static values = {
		selectedYear:  Number,
		selectedMonth: Number
	}

	connect() {
	}

	previousYear() {
		this.resetInputs()
		this.inputYearTarget.value = this.selectedYearValue - 1
		this.submitForm()
	}

	nextYear() {
		this.resetInputs()
		this.inputYearTarget.value = this.selectedYearValue + 1
		this.submitForm()
	}

	previousMonth() {
		this.resetInputs()
		this.inputMonthTarget.value = this.selectedMonthValue + 1
		this.submitForm()
	}

	nextMonth() {
		this.resetInputs()
		this.inputMonthTarget.value = this.selectedMonthValue - 1
		this.submitForm()
	}

	viewMonthly() {
		this.resetInputs()
		this.inputMonthTarget.value = 0
		this.submitForm()
	}

	viewYearly() {
		this.resetInputs()
		this.inputYearTarget.value = this.getCurrentYear()
		this.submitForm()
	}

	viewAll() {
		this.resetInputs()
		this.inputDateRangeTarget.value = 'all'
		this.submitForm()
	}

	resetInputs() {
		this.inputMonthTarget.value     = ''
		this.inputYearTarget.value      = ''
		this.inputDateRangeTarget.value = ''
	}

	submitForm() {
		this.formTarget.requestSubmit()
	}

	getCurrentYear() {
		const date = new Date()
		if (date.getMonth() <= 5) {
			return date.getFullYear()
		} else { 
			return date.getFullYear() + 1
		}
	}

}
